import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { SubsidiaryListState } from 'Types/CompaniesTypes';
import { actions as clusterActions } from 'Slice/ClustersSlice';
import { scrollbar, white } from 'Utils/utilsStyle';
import SubsidiariesGrid from './SubsidiariesGrid';

const Card = styled.div`
  background: ${white};
  border-radius: 16px;
  padding: 24px;
  .subsidiaries-scroll-area {
    max-height: 560px;
    ${scrollbar};
  }
`;

type Props = {
  companyId: number;
  companyName: string;
  entry: SubsidiaryListState;
};

const ClusterSubsidiaryList = function ClusterSubsidiaryList(props: Props) {
  const { companyId, companyName, entry } = props;
  const dispatch = useDispatch();
  // Several companies share the page, so each card scrolls (and paginates) on its own
  const scrollId = `cluster-subsidiaries-scroll-${companyId}`;

  const loadMore = useCallback(() => {
    dispatch(clusterActions.getClusterSubsidiaries({ companyId, page: entry.page }));
  }, [companyId, entry.page]);

  // InfiniteScroll only fires on scroll: if a page doesn't fill the card, fetch the next one
  useEffect(() => {
    if (entry.loading || entry.ended) return;
    const el = document.getElementById(scrollId);
    if (el && el.scrollHeight <= el.clientHeight) loadMore();
  }, [entry.loading, entry.ended, entry.items.length, scrollId, loadMore]);

  return (
    <div className="product-services-section subsidiaries-section">
      <div className="company-name">
        {`${companyName} (${entry.totalCount})`}
      </div>
      <Card>
        <div id={scrollId} className="subsidiaries-scroll-area">
          <SubsidiariesGrid
            companies={entry.items}
            loading={entry.loading}
            ended={entry.ended}
            onLoadMore={loadMore}
            scrollableTarget={scrollId}
          />
        </div>
      </Card>
    </div>
  );
};

export default React.memo(ClusterSubsidiaryList);
